import React from 'react'
import PropTypes from 'prop-types'
// eslint-disable-next-line no-unused-vars
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_Header.scss'
import allanGrayLogoUrl from './Grey_AG_logo.svg'
// eslint-disable-next-line no-unused-vars
import greyAllanGrayLogoUrl from './grey-AG-logo.jpeg' // Used for bundling in the grey logo to be used in emails
import { Navbar, Nav, Row, Col, NavDropdown, Button, Container } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import isEmpty from 'lodash/fp/isEmpty'
import classNames from 'classnames'
import 'bootstrap/dist/css/bootstrap.min.css';

const Header = ({
  activeMenu,
  activeAudience,
  publicPortalUrl,
  navigationLinksFetched,
  audiences,
  mainMenu,
  goToFindAnIFA,
  goToAllanGrayHome,
  goToPendingApprovalProfiles,
  goToAdministrators,
  goToProfile,
  goToAdviserDataDump,
  goToAdviserWhitelisting,
  goToConfigureRateLimiter,
  logout,
  onSetSidebarOpen,
  onMouseEnterDropdown,
  onMouseLeaveDropdown,
  onMouseClickDropdown,
  userLoggedIn,
  administratorLoggedIn,
  userName,
  adviserId
}) => (
  <div>
    {/* Container centres the content (the old react-bootstrap v0 Navbar did this automatically);
        the grey audience bar background stays full-width. */}
    {navigationLinksFetched && !isEmpty(audiences) && <Navbar className={styles['audiences-navbar']}>
      <Container>
        <Row className='justify-content-center w-100'>
          <Col xs={11} sm={11} md={11} lg={11}>
            <ul className={styles['country-selector-margin-right']}>
              {audiences.map((audience, index) => {
                const active = audience.Name === activeAudience ? styles['audiences-navbar-link-active'] : ''
                // Plain <ul><li><a> (like the old BS3 NavItem): RB2 Nav.Item renders a <div> and
                // ignores href, so the links were neither clickable nor styled.
                return <li
                  key={index}
                  className={classNames(styles['audiences-navbar-link'], active)}>
                  <a href={`${publicPortalUrl}${audience.Link}`}>{audience.Name}</a>
                </li>
              })}
            </ul>
          </Col>
        </Row>
      </Container>
    </Navbar>}
    <Navbar collapseOnSelect expand="lg" className={styles['primary-navbar']} >
      <Container>
        <Row className={classNames(styles['header-navbar'], 'justify-content-center', 'w-100')}>
          <Col xs={11} sm={11} md={11} lg={11} className={styles['navbar-column-alignment']}>
              {navigationLinksFetched && <Button variant='link' onClick={() => onSetSidebarOpen(true)}
                className={'btn' + ' ' + styles['primary-navbar-sidebar-toggle']}>
                <FontAwesome name={'bars'} size={'3x'} />
                </Button>}
              <Navbar.Brand >
                <a href={'https://www.allangray.co.za'} className={classNames(styles['navbar-brand-alignment'], styles['navbar-brand-mobile-pull-right'])}>
                  <img src={allanGrayLogoUrl} className={styles['navbar-brand-image']} />
                </a>
              </Navbar.Brand>
            <Navbar.Collapse className={styles['primary-nav']}>
              {navigationLinksFetched && !isEmpty(mainMenu) && <Nav>
                  {mainMenu.map((menuItem, index) => {
                    let firstChildStyle = ''
                    if (index === 0) {
                      firstChildStyle = styles['first-dropdown-element']
                    }
                    return <NavDropdown key={index}
                      title={menuItem.Name}
                      id={`main-menu-${index}-nav-dropdown`}
                      className={styles['nav-dropdown'] + ' ' + firstChildStyle}
                      show={menuItem.open}
                      onToggle={() => onMouseClickDropdown(menuItem.Name)}
                      onClick={() => onMouseClickDropdown(menuItem.Name)}
                      onMouseEnter={() => onMouseEnterDropdown(menuItem.Name)}
                      onMouseLeave={() => onMouseLeaveDropdown(menuItem.Name)}>
                      <div className={styles['nav-dropdown-columns']}
                        style={{ width: `${250 * menuItem.Columns.length}px`, maxWidth: '500px' }}>
                        <Row onMouseLeave={(e) => onMouseLeaveDropdown(menuItem.Name)}>
                          {!isEmpty(menuItem.Columns) && menuItem.Columns.slice(0, 1).map((column, columnIndex) => {
                            const size = (menuItem.Columns.length === 1 ? 12 : 6)
                            return <Col key={columnIndex} xs={12} sm={size} md={size} lg={size}>
                              {column.HideTitle ? null : <h4>{column.Name}</h4>}
                              <ul>
                                {!isEmpty(column.Links) && column.Links.map((columnLink, columnLinkIndex) => {
                                  return <li key={columnLinkIndex} className={styles['nav-dropdown-menu-item']}>
                                    <a href={`${publicPortalUrl}${columnLink.Link.replace('https://www.allangray.co.za', '')}`}>
                                      {columnLink.Name}
                                    </a>
                                  </li>
                                })}
                              </ul>
                            </Col>
                          })}
                          {menuItem.Columns.length < 1 ? null
                            : <Col xs={12} sm={6} md={6} lg={6}>
                              {!isEmpty(menuItem.Columns) && menuItem.Columns.slice(1).map((column, columnIndex) => {
                                return (
                                  // Plain div (not a Bootstrap Row): BS5 .row negative gutters
                                  // bled this sub-column left over the first column.
                                  <div key={columnIndex} className={styles['nav-dropdown-subcolumn']}>
                                    {column.HideTitle ? null : <h4>{column.Name}</h4>}
                                    <ul>
                                      {!isEmpty(column.Links) && column.Links.map((columnLink, columnLinkIndex) => {
                                        return <li key={columnLinkIndex} className={styles['nav-dropdown-menu-item']}>
                                          <a href={`${publicPortalUrl}${columnLink.Link.replace('https://www.allangray.co.za', '')}`}>
                                            {columnLink.Name}
                                          </a>
                                        </li>
                                      })}
                                    </ul>
                                  </div>
                                )
                              })
                              }
                            </Col>
                          }
                        </Row>
                      </div>
                    </NavDropdown>
                  })}
                  {!isEmpty(mainMenu) && userLoggedIn && <NavDropdown
                    show={activeMenu === 'User Menu'}
                    onToggle={() => onMouseClickDropdown('User Menu')}
                    onClick={() => onMouseClickDropdown('User Menu')}
                    onMouseEnter={() => onMouseEnterDropdown('User Menu')}
                    onMouseLeave={() => onMouseLeaveDropdown('User Menu')}
                    title={userName}
                    id='basic-nav-dropdown'
                    className={classNames(styles['nav-dropdown'], styles['user-menu-dropdown'])}>
                    <div className={styles['nav-dropdown-columns']}>
                      <ul>
                        {userLoggedIn && <li className={styles['nav-dropdown-menu-item']}>
                          <a style={{ cursor: 'pointer' }}
                            onClick={() => { goToFindAnIFA(); onMouseLeaveDropdown('User Menu') }}>Find an IFA</a></li>}
                        {userLoggedIn && !administratorLoggedIn && adviserId && <li className={styles['nav-dropdown-menu-item']}>
                          <a style={{ cursor: 'pointer' }}
                            onClick={() => { goToProfile(); onMouseLeaveDropdown('User Menu') }}>Profile</a></li>}
                        {administratorLoggedIn && <li className={styles['nav-dropdown-menu-item']}>
                          <a style={{ cursor: 'pointer' }}
                            onClick={() => { goToPendingApprovalProfiles(); onMouseLeaveDropdown('User Menu') }}>Profiles</a></li>}
                        {administratorLoggedIn && <li className={styles['nav-dropdown-menu-item']}>
                          <a style={{ cursor: 'pointer' }}
                            onClick={() => { goToAdministrators(); onMouseLeaveDropdown('User Menu') }}>Administrators</a></li>}
                        {administratorLoggedIn && <li className={styles['nav-dropdown-menu-item']}>
                          <a style={{ cursor: 'pointer' }}
                            onClick={() => { goToAdviserDataDump(); onMouseLeaveDropdown('User Menu') }}>Data dump</a></li>}
                        {administratorLoggedIn && <li className={styles['nav-dropdown-menu-item']}>
                          <a style={{ cursor: 'pointer' }}
                            onClick={() => { goToAdviserWhitelisting(); onMouseLeaveDropdown('User Menu') }}>Whitelisting</a></li>}
                        {administratorLoggedIn && <li className={styles['nav-dropdown-menu-item']}>
                          <a style={{ cursor: 'pointer' }}
                            onClick={() => { goToConfigureRateLimiter(); onMouseLeaveDropdown('User Menu') }}>Email Rate Limit</a></li>}
                      </ul>
                    </div>
                  </NavDropdown>}
                </Nav>}
              {!isEmpty(mainMenu) && userLoggedIn && <Nav className='ms-auto'>
                <Nav.Item
                  onClick={logout}
                  className={styles['logout-button']}>Logout
                </Nav.Item>
                </Nav>}
            </Navbar.Collapse>
          </Col>
        </Row>
      </Container>
      {/* The colour spectrum gets its OWN Container so it stacks BELOW the header. The Navbar
          forces a single `.container` to be flex-row, which otherwise placed the bar beside the
          nav. A separate Container keeps the bar in line with the header content (as on prod).
          Plain div (not a Bootstrap <Row>) because BS5 `.row > *` forces width:100% on children. */}
      <Container>
        <Row className='justify-content-center w-100'>
          <Col xs={11} sm={11} md={11} lg={11}>
            <div className={styles['navbar-colour-spectrum']}>
              <div className={styles['navbar-colour-spectrum-1']} />
              <div className={styles['navbar-colour-spectrum-2']} />
              <div className={styles['navbar-colour-spectrum-3']} />
              <div className={styles['navbar-colour-spectrum-4']} />
              <div className={styles['navbar-colour-spectrum-5']} />
              <div className={styles['navbar-colour-spectrum-6']} />
              <div className={styles['navbar-colour-spectrum-7']} />
              <div className={styles['navbar-colour-spectrum-8']} />
              <div className={styles['navbar-colour-spectrum-9']} />
            </div>
          </Col>
        </Row>
      </Container>
    </Navbar>
  </div>
  )

Header.propTypes = {
  activeMenu: PropTypes.string,
  activeAudience: PropTypes.string.isRequired,
  publicPortalUrl: PropTypes.string.isRequired,
  navigationLinksFetched: PropTypes.bool.isRequired,
  audiences: PropTypes.array,
  mainMenu: PropTypes.array,
  goToFindAnIFA: PropTypes.func.isRequired,
  goToAllanGrayHome: PropTypes.func.isRequired,
  goToPendingApprovalProfiles: PropTypes.func.isRequired,
  goToAdministrators: PropTypes.func.isRequired,
  goToProfile: PropTypes.func.isRequired,
  goToAdviserDataDump: PropTypes.func.isRequired,
  goToAdviserWhitelisting: PropTypes.func.isRequired,
  goToConfigureRateLimiter: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  onSetSidebarOpen: PropTypes.func.isRequired,
  onMouseEnterDropdown: PropTypes.func.isRequired,
  onMouseLeaveDropdown: PropTypes.func.isRequired,
  onMouseClickDropdown: PropTypes.func.isRequired,
  userLoggedIn: PropTypes.bool.isRequired,
  administratorLoggedIn: PropTypes.bool.isRequired,
  userName: PropTypes.string,
  adviserId: PropTypes.number
}

export default (Header)
